export const API_TIMEOUT = 300000;
export const PageSize = 10;
